<div class="bg-black relative -z-0 h-screen min-w-full container w-fit">
    <div class="p-2 flex gap-2">
        <app-slide-menu class="flex"/>
        <app-central-wrapper class="w-full h-full"/>
    </div>
    <div class="w-full bg-transparent"></div><!--ARREGLAR-->
    @if (this.contextMenu.items.length > 0) {
        <app-contextual-menu [value]="contextMenu" />
    }
</div>